// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"8d21f496","367":"ef675eb8","388":"43f8c879","426":"4133718b","453":"19a30ac3","503":"58aa65d1","504":"3a5521f8","798":"7b9c307a","849":"6a1c6fcb","982":"27c37cce"}[chunkId] + ".chunk.js";
};